// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__ETU76","title":"ClientInsurance_title__3g6hf","itemText":"ClientInsurance_itemText__3Nl2d"};